import React, { Component } from "react";
import { Row, Col, Select, Checkbox, Alert } from "antd";
import axios from "axios";
import { ModalItem, FormItem, ButtonItem, InputItem, InputNumberItem, SelectItem } from "./Items";
import SelectInsumosItem from "./SelectInsumosItem";

const { Option } = Select;

const valoresVacios = {
  insumoSeleccionado: null,
  nombreAlternativo: "",
  clave: "",
  presentacion: "",
  precio: undefined,
  unidadId: undefined,
  conversion: 1,
};

class ModalInsumoParaCliente extends Component {
  state = { ...valoresVacios, objetoUnidades: [], usarDatosOriginales: false };

  componentDidMount() {
    axios
      .post("unidades/selectUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({
            objetoUnidades: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
              </Option>
            )),
          });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      const { item, valoresIniciales } = this.props;
      this.setState(
        item
          ? {
            insumoSeleccionado: { _id: item.insumoId, stringBuscar: `${item.claveInterna || ""} - ${item.descripcion || ""}` },
            nombreAlternativo: item.nombreAlternativo || "",
            clave: item.clave || "",
            presentacion: item.presentacion || "",
            precio: item.precio,
            unidadId: item.unidadId,
            conversion: item.conversion || 1,
            usarDatosOriginales: false,
          }
          : { ...valoresVacios, ...(valoresIniciales || {}), usarDatosOriginales: false }
      );
    }
  }

  guardar = () => {
    const { insumoSeleccionado, nombreAlternativo, clave, presentacion, precio, unidadId, conversion, usarDatosOriginales } = this.state;

    const datosPresentacion = usarDatosOriginales
      ? {
        nombreAlternativo: insumoSeleccionado?.descripcion || nombreAlternativo,
        clave: insumoSeleccionado?.clave || undefined,
        presentacion: undefined,
        unidadId: insumoSeleccionado?.unidadId || undefined,
      }
      : { nombreAlternativo, clave, presentacion, unidadId };

    const esEquivalencia = !!insumoSeleccionado?.insumoPrincipalId;

    this.props.onGuardar({
      insumoId: esEquivalencia ? insumoSeleccionado.insumoPrincipalId : insumoSeleccionado?._id,
      equivalenciaId: esEquivalencia ? insumoSeleccionado._id : undefined,
      insumo: insumoSeleccionado,
      ...datosPresentacion,
      precio,
      conversion,
    });
  };

  render() {
    const { visible, onCancel, loading = false, item, empresaId, headersToken, insumosYaConfigurados } = this.props;
    const { insumoSeleccionado, nombreAlternativo, clave, presentacion, precio, unidadId, conversion, objetoUnidades, usarDatosOriginales } = this.state;
    // Un insumo puede tener varias relaciones con el mismo cliente (otra clave, otra
    // presentación, otro precio de contrato), así que esto sólo AVISA: no bloquea nada.
    // El renglón que se está editando no cuenta como relación previa de sí mismo.
    const identidadesEditando = new Set(
      [item?.insumoId, item?.equivalenciaId].filter(Boolean).map((id) => String(id))
    );
    const identidadElegida = insumoSeleccionado ? String(insumoSeleccionado._id) : null;
    const yaTieneRelacion =
      !!identidadElegida &&
      !identidadesEditando.has(identidadElegida) &&
      (insumosYaConfigurados || []).some((id) => String(id) === identidadElegida);
    const puedeGuardar = usarDatosOriginales ? !!insumoSeleccionado : !!insumoSeleccionado && !!nombreAlternativo.trim();

    return (
      <ModalItem
        title={item ? "Editar Insumo" : "Agregar Insumo"}
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={650}
        spinning={loading}
      >
        <FormItem label="Insumo" margin labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          <SelectInsumosItem
            empresaId={empresaId}
            headersToken={headersToken}
            tiposInsumos="venta"
            value={insumoSeleccionado?._id}
            insumoPreCargado={insumoSeleccionado}
            placeholder="Buscar insumo"
            onChange={(value, insumo) => this.setState({ insumoSeleccionado: insumo })}
          />
        </FormItem>

        {yaTieneRelacion && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message="Ese insumo ya tiene una relación con este cliente"
            description="Se va a crear otra relación aparte. Úsalo cuando el cliente le da otra clave, otra presentación u otro precio al mismo insumo."
          />
        )}

        <FormItem margin labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          <Checkbox
            checked={usarDatosOriginales}
            onChange={(e) => this.setState({ usarDatosOriginales: e.target.checked })}
          >
            Guardar sin datos de presentación para el cliente (usa nombre, clave y unidad del insumo original; solo se captura el precio)
          </Checkbox>
        </FormItem>

        {usarDatosOriginales ? (
          <FormItem label="Precio Unitario" margin labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
            <InputNumberItem
              dinero
              placeholder="Precio Unitario"
              value={precio}
              onChange={(value) => this.setState({ precio: value })}
            />
          </FormItem>
        ) : (
          <>
            <FormItem label="Nombre para el cliente" margin labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
              <InputItem
                placeholder="Nombre que verá el cliente"
                value={nombreAlternativo}
                onChange={(e) => this.setState({ nombreAlternativo: e.target.value })}
              />
            </FormItem>
            <Row gutter={16}>
              <Col span={12}>
                <FormItem label="Clave" margin labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                  <InputItem
                    placeholder="Clave del cliente"
                    value={clave}
                    onChange={(e) => this.setState({ clave: e.target.value })}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Presentación"
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip="Si se captura, en el PDF (pedido, venta y cotización) va a REEMPLAZAR el valor de la Unidad. En pantalla se muestra debajo de la Unidad, sin quitarla."
                >
                  <InputItem
                    placeholder="Ej. Caja 24 pz"
                    value={presentacion}
                    onChange={(e) => this.setState({ presentacion: e.target.value })}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Precio Unitario"
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip="Si se captura, sustituye a la lista de precios en la columna de Precio Unitario al vender/cotizar/pedir a este cliente."
                >
                  <InputNumberItem
                    dinero
                    placeholder="Precio Unitario"
                    value={precio}
                    onChange={(value) => this.setState({ precio: value })}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Unidad" margin labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}>
                  <SelectItem
                    placeholder="Unidad SAT"
                    value={unidadId}
                    onChange={(value) => this.setState({ unidadId: value })}
                  >
                    {objetoUnidades}
                  </SelectItem>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Conversión"
                  margin
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 14 }}
                  tooltip="Por ahora siempre es 1 a 1, no afecta inventarios."
                >
                  <InputNumberItem disabled value={conversion} />
                </FormItem>
              </Col>
            </Row>
          </>
        )}

        <div style={{ display: "flex", justifyContent: "right" }}>
          <ButtonItem type="primary" onClick={this.guardar} disabled={!puedeGuardar}>
            Guardar
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

export default ModalInsumoParaCliente;
